<template>
    <div>
        <NuxtLink :to="url" external :aria-label="title">
            <NuxtImg :src="img" :alt="imgAlt !== '' ? imgAlt : title" />

            <h3 class="py-3">
                {{ title }}
            </h3>
        </NuxtLink>
    </div>
</template>

<script setup lang="ts">

export interface ArticleCardProps {
    title?: string;
    url?: string;
    img?: string;
    imgAlt?: string;
}

const { title, img, url, imgAlt = '' } = defineProps<ArticleCardProps>();

</script>
